// Employee management functionality
import {
    setLoadingState,
    resetLoadingState,
    setupInfiniteScroll,
    setupGenericSearch,
    lookupAddressByCep,
} from "../../utils/common.js";

let paginationInstance = null;

// Employee functionality
$(document).ready(function () {
    // Initialize employees list with infinite scroll
    if ($(".tbodyEmployees").length) {
        paginationInstance = setupInfiniteScroll(
            ".tbodyEmployees",
            "/funcionarios",
            "#currentPage"
        );
    }

    // Initialize search functionality
    if ($("#searchEmployee").length) {
        setupGenericSearch(
            "#searchEmployee",
            "/funcionarios/search",
            ".table-employees",
            ".tbodyEmployees",
            // No extra filters for employees currently
            () => ({})
        );
    }

    // Sync pagination with search results
    $(document).on("search:success", function (e, response, data) {
        if (paginationInstance) {
            paginationInstance.page = 2;

            const hasFilters = data.value && data.value.length > 0;

            if (hasFilters) {
                paginationInstance.config.loadUrl = "/funcionarios/search";
                paginationInstance.config.extraParams = data;
            } else {
                paginationInstance.config.loadUrl = "/funcionarios";
                paginationInstance.config.extraParams = {};
            }

            paginationInstance.loading = false;
        }
    });

    // Handle employee form submission
    $("#employeeForm").on("submit", function (e) {
        e.preventDefault();
        handleEmployeeSubmission(this);
    });

    // Handle employee status toggle
    $(".employee-status-toggle").on("change", function () {
        const employeeId = $(this).data("employee-id");
        const isActive = $(this).is(":checked");
        updateEmployeeStatus(employeeId, isActive);
    });

    // Handle employee role change
    $(".employee-role-select").on("change", function () {
        const employeeId = $(this).data("employee-id");
        const newRole = $(this).val();
        updateEmployeeRole(employeeId, newRole);
    });

    // CEP lookup for employee address
    $("#employeeCep").on("blur", function () {
        const cep = $(this).val().replace(/\D/g, "");
        if (cep.length === 8) {
            lookupAddressByCep(cep, {
                street: "#employeeStreet",
                neighborhood: "#employeeNeighborhood",
                city: "#employeeCity",
                state: "#employeeState",
            });
        }
    });

    // Load workshops for employee assignment
    if ($("#employeeWorkshop").length) {
        loadWorkshopsForEmployee();
    }
});

function handleEmployeeSubmission(form) {
    const submitBtn = $(form).find('button[type="submit"]');
    setLoadingState(submitBtn);

    const formData = new FormData(form);

    $.ajax({
        url: $(form).attr("action"),
        method: $(form).find('input[name="_method"]').val() || "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            if (response.success) {
                // showSuccessMessage('Funcionário salvo com sucesso!'); // Assuming global helper
                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    location.reload();
                }
            } else {
                // showErrorMessage(response.message || 'Erro ao salvar funcionário'); // Assuming global helper
                alert(response.message || "Erro ao salvar funcionário");
            }
        },
        error: function (xhr) {
            resetLoadingState(submitBtn);
            if (xhr.status === 422) {
                // Handle validation errors
                const errors = xhr.responseJSON.errors;
                // implementation depends on how errors are shown
            } else {
                alert("Erro ao processar requisição");
            }
        },
        complete: function () {
            resetLoadingState(submitBtn);
        },
    });
}

// Stub functions for missing implementations (if they were external or inline before)
function updateEmployeeStatus(id, active) {
    // Implement status update logic
}

function updateEmployeeRole(id, role) {
    // Implement role update logic
}

function loadWorkshopsForEmployee() {
    // Implement workshop loading logic
}
